import React from 'react';
export function TextTestimonials() {
  const testimonials = [{
    initials: 'MB',
    name: 'Mónica B.',
    meta: '📍 La Plata · MegaPack + Quema x2',
    quote: 'Hice el pack completo y la diferencia fue tener todo armado. Los ejercicios de 15 minutos los hago mientras cocino la cena. Bajé y tengo más energía.'
  }, {
    initials: 'AF',
    name: 'Adriana F.',
    meta: '📍 Mendoza · MegaPack + Quema x2',
    quote: 'Lo mejor del Quema x2 es que no tenés que pensar nada. El menú ya está listo día por día y las rutinas en casa son cortitas. No necesité gimnasio.'
  }, {
    initials: 'LG',
    name: 'Liliana G.',
    meta: '📍 Rosario · MegaPack + Quema x2',
    quote: 'Tengo 58 años y los ejercicios para la panza y los brazos me cambiaron el cuerpo. Sumado a la comida del plan, en tres semanas ya se notaba.'
  }, {
    initials: 'NT',
    name: 'Norma T.',
    meta: '📍 Buenos Aires · MegaPack + Quema x2',
    quote: 'Seguí el plan de 21 días al pie de la letra. Bajé, los sofocos aflojaron y dormí mejor. Recomendadísimo.'
  }];
  return <section className="bg-brand-deepInk py-16 px-6" data-id="element-296">
      <div className="max-w-[880px] mx-auto" data-id="element-297">
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[34px] text-center text-white uppercase mb-1.5" data-id="element-298">
          ❤️ Más mujeres que ya hicieron el cambio
        </h2>
        <p className="text-center text-brand-muted text-[14px] mb-9" data-id="element-299">
          Clientas que sumaron el Quema x2 al MegaPack
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-300">
          {testimonials.map((testi, i) => <div key={i} className="bg-white/5 border border-brand-border rounded-xl py-4.5 px-5" data-id="element-301">
              <div className="flex items-center gap-3 mb-3" data-id="element-302">
                <div className="w-11 h-11 rounded-full bg-brand-green/15 border border-brand-green/40 text-brand-green font-display text-[14px] font-bold flex items-center justify-center shrink-0" data-id="element-303">
                  {testi.initials}
                </div>
                <div data-id="element-304">
                  <div className="text-[#f5b50a] text-[15px] tracking-[2px] mb-1.5 leading-none" data-id="element-305">
                    ★★★★★
                  </div>
                  <p className="font-display text-[15px] text-white font-semibold leading-[1.2]" data-id="element-306">
                    {testi.name}
                  </p>
                  <p className="text-[11px] text-brand-muted" data-id="element-307">{testi.meta}</p>
                </div>
              </div>
              <p className="text-[13px] text-white/80 italic leading-[1.55]" data-id="element-308">
                "{testi.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}